import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  ref: "stackedBar",
  class: "gfu-nav gfu-nav--lighter gfu-nav__content--large-screen"
}
const _hoisted_2 = { class: "gfu-nav__content gfu-nav__content _jc-c" }
const _hoisted_3 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.navigationTabs, ({ key, href, text, classes }) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key,
          class: _normalizeClass(classes)
        }, [
          _createElementVNode("a", {
            href: href,
            class: "gfu-link"
          }, _toDisplayString(text), 9 /* TEXT, PROPS */, _hoisted_3)
        ], 2 /* CLASS */))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ], 512 /* NEED_PATCH */))
}